module.exports = __webpack_public_path__ + "img/forgot.24021047.svg";